import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../_redux/actions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { EditForm } from "./EditForm";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";
import {CONTEXT, CONTEXT_TITLE} from "../../utils/ModuleHelpers";
import {useIntl} from "react-intl";
import {HTTP_UPDATED, HTTP_CREATED} from "../../../../../_emywork/helpers/AxiosHelpers";
import {AEMetadata} from "../../../../../_emywork/AEPagination";
import {useModuleContext} from "../../ModuleContext";
import {actionTypes} from "../../_redux/slice";
import {getFieldNames} from "../../../../../_emywork/helpers/UIHelper";
import {AEButton} from "../../../../../_emywork/components/buttons";
import {AESVG} from "../../../../../_emywork/components/svg";



export function Edit({ history, match: { params: { id }, }}) {
  // Subheader
  const {openDeleteDialog} = useModuleContext();
  const {formatMessage} = useIntl();
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  const { isLoading, entity, validationErrors, status } = useSelector(s=>s[CONTEXT][actionTypes.Edit], shallowEqual);

  useEffect(() => {
    dispatch(actions.fetchEntity(id,new AEMetadata({},{},{},["*", ...getFieldNames('name')]), actionTypes.Edit));
  }, [id, dispatch]);

  useEffect(() => {
    setTitle(formatMessage( {id: 'FORM.TITLE'}, {isNew:!id, name: formatMessage({id:CONTEXT_TITLE.singular}) } ));
  }, [entity, id]);


  const saveEntity = (values) => {
    if (!id) {
      dispatch(actions.createEntity(values)).then((r) => {
        if(r.status === HTTP_CREATED) {
          history.goBack();
        }

      });
    } else {
      dispatch(actions.updateEntity(values)).then((r) =>{
        if(r.status === HTTP_UPDATED) {
          // history.goBack();
        }

      })
    }
  };

  const btnRef = useRef();

  const saveClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };




  return (
    <>
      <Card>
        {isLoading && <ModalProgressBar />}
        <CardHeader title={title} >
          <CardHeaderToolbar>
            {
              id &&
              <AEButton variant={'light'} fontWeight={"bolder"} onClick={()=>{openDeleteDialog(id)}} className={"mr-5 text-danger"}>
                <AESVG path={"/Navigation/Close.svg"} variant={"danger"} />
                {formatMessage({id:'DELETE'})}
              </AEButton>
            }


            <AEButton variant={'light'} fontWeight={"bolder"} onClick={history.goBack} className={"mr-2"}>
              <AESVG path={"/Navigation/Left-2.svg"} />
              {formatMessage({id:'BACK'})}
            </AEButton>
            <AEButton variant={'light'} fontWeight={"bolder"} onClick={saveClick}  type="submit" className={"mr-2 text-primary"}>
              <AESVG path={"/Navigation/Double-check.svg"} variant={"primary"}/>
              {formatMessage({id:'SAVE'})}
            </AEButton>

          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <EditForm
            entity={{...entity}}
            btnRef={btnRef}
            saveEntity={saveEntity}
            validationErrors={validationErrors}
          />
        </CardBody>
      </Card>
    </>
  );
}
